import axios from 'axios';
import { INTERNSHIP_APP_API } from '../Config/config';

/**
 * Asks the API whether the application is in maintenance mode (the MaintenanceMode setting of the function app).
 * No sign-in is needed and the database is not used, so it answers while the database is being worked on.
 * If the answer can't be read the application is treated as available: a problem of this check must not lock the
 * users out.
 */
export async function fetchMaintenanceStatus(): Promise<boolean> {
  try {
    const response = await fetch(`${INTERNSHIP_APP_API}/maintenance`, {
      cache: 'no-store',
    });
    if (!response.ok) {
      return false;
    }

    const status = (await response.json()) as { maintenance?: boolean };
    return status.maintenance === true;
  } catch {
    return false;
  }
}

/**
 * While the application is in maintenance mode every endpoint answers with 503 and { maintenance: true }.
 * A 503 without it is an ordinary failure, not the maintenance.
 */
export function isMaintenanceError(error: unknown): boolean {
  if (!axios.isAxiosError(error) || error.response?.status !== 503) {
    return false;
  }

  return (
    (error.response.data as { maintenance?: boolean } | undefined)
      ?.maintenance === true
  );
}
